module.exports = __webpack_public_path__ + "img/loader.b4406937.gif";